<template>
  <tabs @TabChange="onTabChange" centered position="bottom" type="neutral" tab-nav-wrapper-classes="card-header-nav icon" tab-content-classes="tab-content-padding tab-no-space " v-model="activeTab">

    <tab-pane label="chat-message">
      <template slot="label">
        <i class="fas fa-comment-alt" />
      </template>

      <chat style="position: fixed;width: 100%;bottom: 0px;height: 93.2vh;" v-if="patientAdmission && patient" :id="patientAdmission._id" context="bed" :headerText="`${patient.firstName} ${patient.lastName}`">
      </chat>

    </tab-pane>

    <tab-pane label="patient-history">
      <template slot="label">
        <i class="fa fa-user" />
      </template>
      <tabs type="primary" centered class="patient-history-tabs" tab-nav-wrapper-classes="p-0" style="padding-top:1em;">
        <!-- Bio -->
        <tab-pane label="Bio">
          <template slot="label">
            <span class="pl-2">{{ $t("message.Bio") }}</span>
          </template>
          <div class="col-12" v-if="patient">
            <div class="row">
              <div class="col-12 text-center">
                <img :src="require('@/assets/img/proAvatar.png')" style="width: 100px; height: 100px; border-radius: 50%" v-if="!patient.profileImage" />
                <profile-image :file-id="patient.profileImage" image-style="width: 100px; height: 100px; border-radius: 50%; margin: auto;" v-if="patient.profileImage">
                </profile-image>
              </div>
              <div class="col-12 text-center mt-3">
                {{ patient.patientId }}
                <h6 class="mt-2">
                  {{ patient.firstName }} {{ patient.lastName }}
                </h6>
                {{ getAge(patient.dob) }}
                <br />
                <div style="font-size: 30px">
                  <span v-if="patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                    <i class="fa fa-mars"></i>
                  </span>
                  <span v-if="patient.gender == 'female'" style="color: rgb(235, 63, 157)">
                    <i class="fa fa-venus"></i>
                  </span>
                  <span v-if="patient.gender == 'others'" style="color: rgb(33, 243, 208)">
                    <i class="fa fa-transgender-alt"></i>
                  </span>
                </div>
              </div>

              <div class="col-12 mt-5" v-if="patientIdFile">
                <card>
                  <div slot="header">
                    <h6>{{ $t("message.Patient ID") }}</h6>
                  </div>
                  <div class="col-12 text-center">
                    <dynamic-image :file-id="patientIdFile.fileId" image-style="max-height: 245px">
                    </dynamic-image>
                  </div>
                </card>
              </div>
            </div>
          </div>
        </tab-pane>

        <!-- Vitals history -->
        <tab-pane label="Vitals">
          <template slot="label">
            <span @click="getVitalHistory()" class="pl-2">{{ $t("message.Vitals") }}</span>
          </template>
          <div v-if="deviceProfile && deviceProfile.length>0" class="col-12" style="height: 100%; overflow: scroll;">
            <div class="row">
              <div class="col-md-6 col-lg-4" v-for="(device, index) in deviceProfile" :key="device.identifier" :id="device.identifier">
                <vital-card :deviceforcard="device" :vitals="device.vitals" :vital-index="index" ref="vitalComponents" v-if="device.communication.communicationMethod != 'NOTIFY'" :error-messages="errorMessages" :allowManualEntry="false" :allowRetrieval="false" :hideVitalHistory="false" :historic-vitals="historicVitals" :disableInputs="true" :shareVitals="shareVitals" :shareButton="false" :vital-group="false"></vital-card>

                <span v-if="vitalDevice && vitalDevice.vitalsGroup && IS_NURSE" style="width:100%">
                  <div v-for="group in  vitalDevice.vitalsGroup" :key="group.identifier" style="padding:0px;width:100%">
                    <vital-card :deviceforcard="device" :vitals="group.vitals" :vital-index="index" ref="vitalComponents" v-if="device.communication.communicationMethod != 'NOTIFY' && device.vitalsGroup" :error-messages="errorMessages" :allowManualEntry="false" :allowRetrieval="false" :hideVitalHistory="false" :historic-vitals="historicVitals" :disableInputs="true" :shareVitals="shareVitals" :shareButton="false" :vital-group="false"></vital-card>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div v-else class="no-device-profile" style="
                    text-align: center;">
            <h5 style="margin-top: 10vh;">{{ $t("message.No vitals available") }}</h5>
            <vitals-not-configured-svg style="height: 39vh; width: 63vw;"></vitals-not-configured-svg>
          </div>
        </tab-pane>

        <!-- Files history -->
        <tab-pane label="Files">
          <template slot="label">
            <span class="pl-2">{{ $t("message.Files") }}</span>
          </template>
          <div class="col-12" style="overflow-y: scroll;overflow-x: hidden;height: 100%;">
            <div>
              <div class="col-12 mt-5 text-center" v-if="!historicFiles || historicFiles.length < 1">
                {{ $t("message.No files for the patient") }}
              </div>
              <div class="col-12 file-list" v-for="file in historicFiles" :key="file.fileId">
                <div>
                  <div class="col-12">
                    <div class="row">
                      <div class="col-2 col-md-2 col-lg-2">
                        <div v-if="file.type.indexOf('image') > -1">
                          <dynamic-image :file-id="file.fileId" image-style="min-height: 20px; width: 100%" @click.native="viewFile(file)">
                          </dynamic-image>
                        </div>
                        <div v-else-if="file.type.indexOf('pdf') > -1">
                          <i class="fa fa-file-pdf" style="font-size: 2em; color: #208fdc"></i>
                        </div>
                        <div v-else-if="file.type.indexOf('video') > -1">
                          <i class="fa fa-file-video" style="font-size: 2em; color: #208fdc"></i>
                        </div>
                        <div v-else-if="file.type.indexOf('audio') > -1">
                          <i class="fa fa-file-audio" style="font-size: 2em; color: #208fdc"></i>
                        </div>
                        <div v-else>
                          <i class="fa fa-file" style="font-size: 2em; color: #208fdc"></i>
                        </div>
                      </div>
                      <div class="col-8 col-md-8 col-lg-8" @click="viewFile(file)">
                        <p class="card-heading">{{ file.name }}</p>
                        <p class="card-heading file-date">
                          {{ getFormattedDate(file.created) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>

        <!-- Prescription history -->
        <tab-pane label="Notes">
          <template slot="label">
            <span class="pl-2">{{ $t("message.Notes") }}</span>
          </template>
          <div class="col-12" style="height: 100%; overflow: scroll;">
            <div v-if="historicPrescriptions">
              <div class="row">
                <div class="col-12" v-if="!selectedPrescription">
                  <!-- List for extra small devices -->
                  <div class="row d-block d-md-block">
                    <div class="col-12 prescription-list" v-for="prescription in historicPrescriptions" :key="prescription._id">
                      <div @click="viewPrescription(prescription)">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-2 col-md-1">
                              <i class="el-icon-tickets prescription-icon"></i>
                            </div>
                            <div class="col-10 col-md-11">
                              <p class="card-heading reason">
                                {{ prescription.reason }}
                              </p>
                              <p class="card-heading mb-0">
                                {{ $t("message.Dr") }} .
                                {{ prescription.provider.firstName }}
                                {{ prescription.provider.lastName }}
                              </p>
                              <p class="card-heading">
                                {{
                                        getFormattedDate(prescription.created)
                                      }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="historicPrescriptions.length < 1" class="col-12 text-center">
                      <i class="fa fa-info-circle"></i>
                      {{ $t("message.No Prescriptions available") }}
                    </div>
                  </div>
                </div>

                <div v-if="selectedPrescription">
                  <n-button type="primary" round @click.native="selectedPrescription = null" icon style="position: fixed;left:1em; top:10em; z-index: 1">
                    <i class="now-ui-icons arrows-1_minimal-left"></i>
                  </n-button>
                  <card>
                    <view-prescription :prescription_="selectedPrescription.prescriptions" v-if="selectedPrescription" :appointment="selectedPrescription"></view-prescription>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>

        <!-- patient laborders -->
        <tab-pane label="Laborders">
          <template slot="label">
            <span class="pl-2">{{ $t("message.Lab Tests") }}</span>
          </template>
          <div class="col-12" style="height: 100%; overflow: scroll;">
            <div v-if="patientLaborders">
              <div class="row align-items-center">
                <div class="col-12" v-if="!selectedLaborder">
                  <div class="row d-block d-md-block">
                    <div class="col-12 prescription-list" v-for="laborder in patientLaborders" :key="laborder._id">
                      <div @click="viewSelectedLaborder(laborder)">
                        <div class="col-12">
                          <div class="row align-items-center">
                            <div class="col-2 col-md-1">
                              <i class="fa fa-microscope" style="font-size: 2em; color: #2ca8ff;"></i>
                            </div>
                            <div class="col-10 col-md-11">
                              <p class="card-heading mb-0">
                                <span v-for="labTest in laborder.labTests" :key="labTest._id">
                                  {{labTest.name}}
                                </span>
                              </p>
                              <p class="card-heading">
                                {{getFormattedDate(laborder.created)}}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="patientLaborders.length < 1" class="col-12 text-center">
                      <i class="fa fa-info-circle"></i>
                      {{ $t("message.No lab orders") }}
                    </div>
                  </div>
                </div>

                <div v-if="selectedLaborder" style="width: 100%;">
                  <n-button type="primary" round @click.native="selectedLaborder = null" icon style="position: fixed; top:10em; z-index: 1; inset-inline-start: 1em;">
                    <i class="now-ui-icons arrows-1_minimal-left"></i>
                  </n-button>
                  <view-laborder :laborder="selectedLaborder" v-if="selectedLaborder"></view-laborder>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>
      </tabs>
    </tab-pane>

    <tab-pane label="tasks">
      <template slot="label">
        <i class="fas fa-tasks"></i>
      </template>

      <div class="col-12 task-status" style="display: flex;justify-content: space-around;align-items: center;">
        <div class="col-8 col-md-8 form-group" style="padding: 0px 3px;margin: 0px;">
          <el-select class="select-primary" size="large" name="latestStatus" placeholder="Latest Status" v-model="latestStatusQuery">
            <el-option class="select-primary" value="Initiated" label="Active / Upcoming"></el-option>
            <el-option class="select-primary" value="Created" label="Scheduled"></el-option>
            <el-option class="select-primary" value="Completed" label="Completed"></el-option>
          </el-select>
        </div>
      </div>

      <div class="col-12 task-date" style="display: flex;justify-content: center;align-items: center;padding: 0.5em 0px;">
        <i class="fas fa-chevron-circle-left" style="font-size:2em" @click="goToPreviousDate"></i>
        <div class="col-5 col-md-5 form-group" style="padding: 0px 3px;margin: 0em 2em;">
          <el-date-picker placeholder='Select Date' v-model="dateQuery" format="dd-MM-yyyy" type="date" align="center" :picker-options="{}" :editable="false"></el-date-picker>
        </div>
        <i class="fas fa-chevron-circle-right" style="font-size:2em" @click="goToNextDate"></i>
      </div>

      <div class="col-12" style="display: flex;justify-content: space-around;align-items: center;">
        <div class="col-8 col-md-8 form-group" style="padding: 0px 3px;margin: 0px;">
          <el-select class="select-primary" size="large" name="taskType" placeholder="All Types" v-model="taskTypeQuery">
            <el-option class="select-primary" value="" label="All Types"></el-option>
            <el-option class="select-primary" value="Medication" label="Medication"></el-option>
            <el-option class="select-primary" value="Vitals Observation" label="Vitals Observation"></el-option>
            <el-option class="select-primary" value="Procedure" label="Procedure"></el-option>
            <el-option class="select-primary" value="Specimen Colletion" label="Specimen Colletion"></el-option>
            <el-option class="select-primary" value="IO Observation" label="IO Observation"></el-option>
            <el-option class="select-primary" value="Others" label="Others"></el-option>
          </el-select>
        </div>
      </div>

      <div class="col-12" v-if="!tasks || tasks.length == 0" style="display: flex;justify-content: center;align-items:center;height: 8em;">
        <i class="fa fa-info-circle" style="padding-right: 0.5em;"></i> No tasks available.
      </div>
      <div class="col-12 tasks-list" style="height: 67vh;overflow:scroll;padding-top:1em" v-else>
        <card class="card-stats rounded" v-for="task in tasks" :key="task._id" @click.native="selectTask(task)">
          <div class="statistics statistics-horizontal">
            <div class="info info-horizontal">
              <div class="row visit-details details">
                <div class="col-2 col-md-2 pr-0" style="font-size: 1.5em;display: flex;justify-content: center;align-items: center;">
                  <i class="fas fa-pills" v-if="task.taskType === 'Medication'"></i>
                  <i class="fas fa-notes-medical" v-else-if="task.taskType === 'Vitals Observation' || task.taskType === 'IO Observation'"></i>
                  <i class="fas fa-th-list" v-else></i>
                </div>
                <div class="col-10 col-md-10 right" style="display: grid;align-content: center;">
                  <!--                   <div class="row">
                    <div class="col-12" style="display: flex;justify-content: end;">
                      <span style="font-size: 0.8em;">
                        <i class="fas fa-clock"></i>
                        {{ getFormattedTime(task.schedule.start) }}
                      </span>
                    </div>
                  </div> -->
                  <div class="row">
                    <div class="col-7">
                      <span class="badge badge-task-type" :class="'badge-task-type-' + (task.taskType === 'Vitals Observation' || task.taskType === 'IO Observation' ? 'Observation' : task.taskType)">
                        {{ task.taskType }}
                      </span>
                    </div>
                    <div class="col-5" style="display: flex;justify-content: end;padding-left: 0px;" v-if="task.latestStatus == 'Initiated'">
                      <span style="font-size: 0.8em;" v-if="getRemainingTimeForTask(task.schedule.end).type == 'remaining'">
                        <i class="fas fa-stopwatch"></i>
                        {{ getRemainingTimeForTask(task.schedule.end).time }} {{ getRemainingTimeForTask(task.schedule.end).unit }} left
                      </span>
                      <span style="font-size: 0.8em;color: red;" v-if="getRemainingTimeForTask(task.schedule.end).type == 'overdue'">
                        <i class="fas fa-exclamation-circle"></i>
                        Due by {{ getRemainingTimeForTask(task.schedule.end).time }} {{ getRemainingTimeForTask(task.schedule.end).unit }}
                      </span>
                      <span style="font-size: 0.8em;" v-if="getRemainingTimeForTask(task.schedule.end).type == 'now'">
                        <i class="fas fa-stopwatch"></i>
                        Now
                      </span>
                    </div>
                    <div class="col-5" style="display: flex;justify-content: end;" v-else>
                      <span style="font-size: 0.8em;">
                        <i class="fas fa-clock"></i>
                        {{ getFormattedTime(task.schedule.start) }}
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <span style="font-size: 1.2em;font-weight: 500;">{{task.title }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>

      <modal :show.sync="showTaskModal" headerclasses="justify-content-center" :showClose="false">
        <h6 v-if="selectedTask && showTaskModal" slot="header" class="title title-up">{{selectedTask.title}}</h6>
        <div v-if="selectedTask && showTaskModal" class="col-12" style="padding: 0px;max-height: 79vh;overflow: scroll;">
          <div class="col-12 text-center" style="padding: 0px;display: flex;justify-content: center;" v-if="selectedTask && selectedTask.latestStatus != 'Completed'">
            <div class="col-8 text-center" style="padding: 0px;">
              <el-date-picker placeholder='Now' v-model="selectedTask.taskCompletedTimestamp" type="datetime" align="center" :picker-options="{}" :editable="false"></el-date-picker>
            </div>
          </div>
          <div class="col-12" style="padding: 0px;margin-top: 1.5em;">
            <div class="row" v-if="selectedTask.description">
              <div class="col-6 details-lable">
                Description:
              </div>
              <div class="col-6">
                {{selectedTask.description}}
              </div>
            </div>
            <div class="row">
              <div class="col-6 details-lable">
                Status:
              </div>
              <div class="col-6">
                {{selectedTask.latestStatus}}
              </div>
            </div>
            <div class="row">
              <div class="col-6 details-lable">
                Duration:
              </div>
              <div class="col-6" v-if="selectedTask.duration">
                {{selectedTask.duration}} mins
              </div>
            </div>
            <div class="row">
              <div class="col-6 details-lable">
                Scheduled For:
              </div>
              <div class="col-6">
                {{getFormattedDateTime(selectedTask.schedule.start,'DD/MM/YY, HH:mm')}}
              </div>
            </div>
            <div class="row" v-if="selectedTask.latestStatus == 'Completed' && selectedTask.taskCompletedTimestamp">
              <div class="col-6 details-lable">
                Completed On:
              </div>
              <div class="col-6">
                {{getFormattedDateTime(selectedTask.taskCompletedTimestamp,'DD/MM/YY, HH:mm')}}
              </div>
            </div>
          </div>
          <div class="col-12" style="padding: 0px;margin-top: 1.5em;max-height: 59vh;overflow: scroll;" v-if="showTaskForm">
            <form-renderer :schema="selectedTask && selectedTask.latestStatus == 'Completed' ? selectedTask.data : selectedTask.taskForm" model :read-only="selectedTask && selectedTask.latestStatus == 'Completed' ? true : false" ref="formRenderer"></form-renderer>
          </div>
        </div>
        <div class="col-12 text-center" slot="footer">
          <n-button type="primary" simple class="btn-padding light mr-2" round style="padding:10px 22px;height: 3em;" @click.native="showTaskModal=false;showTaskForm = false;">
            <i class="fas fa-times"></i>
            Close
          </n-button>
          <n-button type="primary" class="btn-padding light" round style="padding:10px 22px;height: 3em;" @click.native="completeTask" v-if="selectedTask && selectedTask.latestStatus != 'Completed'">
            <i class="fas fa-check"></i>
            Complete
          </n-button>
        </div>
      </modal>
    </tab-pane>

    <call-notification v-if="callNotification" :caller="caller" :callType="callType" @call-declined="onCallDeclined()" @call-accepted="onCallAccepted()" @call-missed="onCallMissed()" @call-cancelled="onCallCancelled()">
    </call-notification>

    <!-- VC -->
    <tab-pane label="video-call" :class="{ 'video-call-tab': draggable }" id="video-call-tab">
      <template slot="label">
        <i class="fa fa-video" style="position: relative;">
          <div class="la-ball-scale-multiple la-dark video-active" style="
                  position: absolute;
                  top: -6px;
                  left: -5px;
                  color: var(--color-primary);
                  display: none;
                ">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </i>
      </template>

      <VueDragResize :parentLimitation="true" v-if="showVideo" :axis="'both'" :preventActiveBehavior="preventActiveBehavior" :isDraggable="draggable" :isResizable="false" :z="1030" :w="'auto'" :h="'auto'" :y="floatingVideoPositionTop" :x="20" :contentClass="contentClass">
        <div :class="vmaatuClass">
          <vmaatu :query="simpleMeetingsQuery" v-if="settings &&
            user.endpoint &&
            user.endpoint.videoConfEPType == 'VMAATU_RTC' &&
            simpleMeetingsQuery
            " ref="vmaatu" :waiting-msg="waitingMsg" :hide-controls="hideVmaatuControls"></vmaatu>

          <n-button type='danger' size="md" class="end-button" @click.native="endCall()" v-if="showVideo">
            <i class="fas fa-phone-slash"></i>
            {{ $t("message.End") }}
          </n-button>

        </div>
      </VueDragResize>

      <div class="floating-ptz" v-if="REMOTE_EP_PTZ_ENABLED && IS_DOCTOR && (showVideo)">
        <div class="circleMenu">
          <nav>
            <ul class="outer">
              <li>
                <span class="mainBtn" @click="ptzExecute('reset', 'None')" @contextmenu="false">
                  <i class="fa fa-sync-alt" style="margin-left: 31%;margin-top: 31%;color: #637BEF;font-size: 1.3em;"></i>
                </span>
                <ul class="inner" @contextmenu="false">
                  <li @mousedown="ptzExecute('pan', 'Left')" @mouseup="ptzExecute('pan', 'Stop')" @touchstart="ptzExecute('pan', 'Left')" @touchend="ptzExecute('pan', 'Stop')" @contextmenu="false"><i class="fa fa-chevron-left fa-2x"></i></li>
                  <li @mousedown="ptzExecute('tilt', 'Up')" @mouseup="ptzExecute('tilt', 'Stop')" @touchstart="ptzExecute('tilt', 'Up')" @touchend="ptzExecute('tilt', 'Stop')" @contextmenu="false"><i class="fa fa-chevron-up fa-2x"></i></li>
                  <li @mousedown="ptzExecute('pan', 'Right')" @mouseup="ptzExecute('pan', 'Stop')" @touchstart="ptzExecute('pan', 'Right')" @touchend="ptzExecute('pan', 'Stop')" @contextmenu="false"><i class="fa fa-chevron-right fa-2x"></i></li>
                  <li @mousedown="ptzExecute('tilt', 'Down')" @mouseup="ptzExecute('tilt', 'Stop')" @touchstart="ptzExecute('tilt', 'Down')" @touchend="ptzExecute('tilt', 'Stop')" @contextmenu="false">
                    <i class="fa fa-chevron-down fa-2x"></i>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <ul class="zoom-buttons" @contextmenu="false" v-if="REMOTE_EP_PTZ_ENABLED && IS_DOCTOR && (showVideo)">
        <li @mousedown="ptzExecute('zoom', 'In')" @mouseup="ptzExecute('zoom', 'Stop')" @touchstart="ptzExecute('zoom', 'In')" @touchend="ptzExecute('zoom', 'Stop')" @contextmenu="false">
          <span class="fa-stack fa-lg">
            <i class="fa fa-circle fa-stack-2x"></i>
            <i class="fa fa-search-plus fa-stack-1x fa-inverse zoom-in" style="position: absolute;left: 21%;"></i>
          </span>
        </li>
        <li @mousedown="ptzExecute('zoom', 'Out')" @mouseup="ptzExecute('zoom', 'Stop')" @touchstart="ptzExecute('zoom', 'Out')" @touchend="ptzExecute('zoom', 'Stop')" @contextmenu="false">
          <span class="fa-stack fa-lg">
            <i class="fa fa-circle fa-stack-2x"></i>
            <i class="fa fa-search-minus fa-stack-1x fa-inverse zoom-out" style="position: absolute;left: 21%;"></i>
          </span>
        </li>
      </ul>

      <n-button type="primary" icon round simple size="lg" v-if="!showVideo && activeTab == 'video-call'" @click.native="makeVideoCall()" class="make-video-call-button">
        <i class="fa fa-video" />
      </n-button>

      <!-- slow internet message -->
      <card class="rounded primary" v-if="SHOW_SLOW_REMOTE_NETWORK_MESSAGE" style="position: fixed; bottom: 10em; left: 50%;
              background: #e7e7e7;
              transform: translateX(-50%);
              width: 80vw;
              z-index: 99999;">
        <div>
          <div class="row">
            <div class="col-10">
              Slow internet detected on remote side
            </div>
            <div class="col-2" @click="SHOW_SLOW_REMOTE_NETWORK_MESSAGE = false">
              <i class="fas fa-times"></i>
            </div>
          </div>
        </div>
      </card>

      <p v-if="!showVideo && activeTab == 'video-call'" class="start-video-text"> {{ $t("message.Connect to remote doctor")
      }}
      </p>

    </tab-pane>
  </tabs>
</template>

<script>
import { TabPane, Tabs } from "src/components";
import VitalsNotConfiguredSvg from "./components/svg_images/VitalsNotConfiguredSvg.vue";
import Chat from "./components/ChatComponent.vue";
import FormRenderer from "src/pages/carenation/components/FormRenderer.vue";
import socket from "@/services/socket";
import CallNotification from "../../components/CallNotification";

export default {
  components: {
    TabPane,
    Tabs,
    VitalsNotConfiguredSvg,
    Chat,
    FormRenderer,
    CallNotification,
  },

  data() {
    return {
      patientAdmission: null,
      patient: null,
      vitals: {},
      historicVitals: null,
      historicFiles: [],
      historicPrescriptions: [],
      selectedPrescription: null,
      FETCHED_HISTROIC_VITALS: false,
      loader: null,
      deviceProfile: [],
      activeTab: "chat-message",
      patientIdFile: null,
      SHOW_PRESCRIPTION_PREVIEW: false,
      LOADING_PRESCRIPTION: false,
      patientLaborders: null,
      selectedLaborder: null,
      tasks: [],
      latestStatusQuery: "Initiated",
      taskTypeQuery: "",
      dateQuery: new Date(),
      selectedTask: null,
      showTaskModal: false,
      showTaskForm: false,
      callNotification: false,
      caller: {},
      callType: "",
      showVideo: false,
      simpleMeetingsQuery: null,
      SHOW_SLOW_REMOTE_NETWORK_MESSAGE: false,
      REMOTE_EP_PTZ_ENABLED: false,
      waitingMsg: "Please wait while doctor joins...",
    };
  },

  computed: {
    draggable() {
      return this.activeTab == "video-call" ? false : true;
    },
    settings() {
      return this.$store.state.settings;
    },
    preventActiveBehavior() {
      return this.activeTab == "video-call" ? true : false;
    },
    floatingVideoPositionTop() {
      return window.innerHeight - 264;
    },
    contentClass() {
      return this.activeTab == "video-call"
        ? "non-draggable-content"
        : "draggable-content";
    },
    vmaatuClass() {
      if (this.activeTab == "video-call") {
        return "fullscreen-window";
      } else {
        if (!this.mountedLoader) {
          return "draggable-window";
        } else {
          return "fullscreen-window";
        }
      }
    },
  },

  async mounted() {
    let that = this;
    try {
      let bedId = this.$route.params.bedId;
      this.patientAdmission = await this.getPateintAdmissions(bedId);

      socket.emit("joinRoom", {
        id: this.patientAdmission._id,
        type: "icumonitoring",
        userId: this.user._id,
      });

      let patientId = this.patientAdmission.patientId;
      this.patient = await this.getPateintDetails(patientId);
      this.changeAppHeaderText(
        `ICU bed chat - ${this.patient.firstName} ${this.patient.lastName}`
      );

      //Get files history
      try {
        this.historicFiles = (
          await this.$store.dispatch("getFilesHistory", this.patient.patientId)
        ).data;
      } catch (e) {
        console.log(e);
      }

      //Get prescription history
      try {
        this.historicPrescriptions = (
          await this.$store.dispatch("getPrescriptionsHistory", {
            patientId: this.patient.patientId,
          })
        ).data;
      } catch (e) {
        console.log(e);
      }

      // get lab orders by patient
      if (this.patient) {
        this.patientLaborders = await this.$store.dispatch(
          "getLabordersByPatient",
          { patientId: this.patient.patientId }
        );
      }
      await this.getFilteredTasks();

      socket.on("icumonitoring:call-accept", (data) => {
        console.log("call accept");
        if (this.callNotification && this.callType == "outgoing") {
          this.callNotification = false;
          this.showVideo = true;
          setTimeout(() => {
            that.$refs.vmaatu.init();
            console.log("vmaatu init");
          }, 1000);
          this.hideVmaatuControls = false;
        }
      });

      socket.on("icumonitoring:call-end", (data) => {
        console.log("call end");

        if (this.$refs.vmaatu) {
          this.$refs.vmaatu.destroy();
        }
        this.showVideo = false;
      });

      let simpleMeetingsQuery = {
        api_key: this.settings.vMaatuSettings.apikey,
        room_name: this.instance + "_" + this.patientAdmission._id,
        user_name: this.user.username,
        tenant_name: this.user.tenant.name,
        instance: this.instance,
      };

      this.simpleMeetingsQuery = simpleMeetingsQuery;
    } catch (error) {
      console.log(error);
    }
  },

  methods: {
    async getPateintAdmissions(bedId) {
      let patientAdmission = (
        await this.$store.dispatch("getPatientAddmissions", {
          locationId: bedId,
          latestStatus: "Admitted",
        })
      ).data[0];

      return patientAdmission;
    },

    async getPateintDetails(patientId) {
      return await this.$store.dispatch("getPatientByPatientId", patientId);
    },

    async getFilteredTasks() {
      let res = await this.$store.dispatch("getFilteredTasks", {
        patientAdmission: this.patientAdmission._id,
        taskType: this.taskTypeQuery,
        taskDateRange: {
          fromDate: new Date(this.dateQuery).setHours(0, 0, 0, 0),
          toDate: new Date(this.dateQuery).setHours(23, 59, 59, 999),
        },
        status: this.latestStatusQuery,
      });
      if (res && res.data) {
        this.tasks = res.data;
      }
    },

    goToNextDate() {
      this.dateQuery = moment(this.dateQuery).add(1, "days")._d;
    },

    goToPreviousDate() {
      this.dateQuery = moment(this.dateQuery).subtract(1, "days")._d;
    },

    selectTask(task) {
      this.selectedTask = task;
      this.selectedTask.taskCompletedTimestamp = null;
      let taskForm = null;
      try {
        taskForm = JSON.parse(task.taskForm);
      } catch {
        taskForm = null;
      }
      if (taskForm && taskForm.fields && taskForm.fields.length > 0) {
        this.showTaskForm = true;
      }
      this.showTaskModal = true;
    },

    async completeTask() {
      try {
        let data = null;
        if (this.$refs.formRenderer) {
          data = this.$refs.formRenderer.getData();
        }
        try {
          data = JSON.stringify(data);
        } catch {
          data = null;
        }
        let taskCompletedTimestamp = null;
        if (this.selectedTask.taskCompletedTimestamp) {
          taskCompletedTimestamp = new Date(
            this.selectedTask.taskCompletedTimestamp
          ).getTime();
        } else {
          taskCompletedTimestamp = new Date().getTime();
        }
        await this.$store.dispatch("completeTask", {
          data,
          id: this.selectedTask._id,
          taskCompletedTimestamp,
        });

        swal.fire({
          type: "success",
          title: "Task updated successfully!",
          timer: 3000,
        });
        this.showTaskModal = false;
        this.showTaskForm = false;
        this.getFilteredTasks();
      } catch (e) {
        console.error(e);
        swal.fire({
          type: "error",
          title: "Error updating the task!",
          timer: 3000,
        });
      }
    },

    getFormattedDateTime(timestamp, format) {
      if (!format) {
        format = "DD/MM/YY hh:mm a";
      }
      return moment(timestamp).format(format);
    },

    onTabChange(label) {
      this.activeTab = label;
      if (this.activeTab === "chat-message") {
        this.changeAppHeaderText(
          `ICU bed chat - ${this.patient.firstName} ${this.patient.lastName}`
        );
      } else {
        this.changeAppHeaderText(label);
      }
    },
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm a");
    },

    async getVitalHistory() {
      try {
        this.historicVitals = await this.$store.dispatch("getVitalHistory", {
          patientId: this.patient.patientId,
          deviceProfile: this.deviceProfile,
          fromTime: moment().subtract(30, "days").unix() * 1000,
          toTime: moment().unix() * 1000,
        });
      } catch (e) {
        console.log(e);
      }
    },
    getFormattedTime(timestamp, format) {
      if (!format) {
        format = "hh:mm A";
      }
      return moment(timestamp).format(format);
    },
    getRemainingTimeForTask(endTime) {
      let diff = moment(endTime).diff(new Date(), "hours");
      let type = "remaining";

      if (diff == 0) {
        type = "now";
      } else if (diff < 0) {
        type = "overdue";
      }

      let absoluteDiff = Math.abs(diff);
      return {
        time: absoluteDiff,
        unit: "hour" + (absoluteDiff > 1 ? "s" : ""),
        type: type,
      };
    },

    makeVideoCall() {
      socket.emit("icumonitoring:call", {
        patientAdmission: this.patientAdmission._id,
        initiatedBy: this.user._id,
      });

      this.callType = "outgoing";
      this.caller.name = "Remote Doctor";
      this.callNotification = true;
      this.outGoingCall = true;
    },
    onCallCancelled() {
      this.callNotification = false;
    },

    async endCall() {
      swal
        .fire({
          title: this.$t("message.Are you sure you want to end the call?"),
          confirmButtonText: this.$t("message.End call"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.Stay"),
          confirmButtonColor: "#FF3636",
          cancelButtonColor: "#18ce0f",
        })
        .then(async (result) => {
          if (result && result.value) {
            if (this.$refs.vmaatu) {
              this.$refs.vmaatu.destroy();
            }
            this.showVideo = false;
            socket.emit("icumonitoring:call-end", {
              patientAdmission: this.patientAdmission._id,
              initiatedBy: this.user._id,
            });
          }
        });
    },
  },
  watch: {
    dateQuery: async function () {
      await this.getFilteredTasks();
    },
    taskTypeQuery: async function () {
      await this.getFilteredTasks();
    },
    latestStatusQuery: async function () {
      await this.getFilteredTasks();
    },
  },
};
</script>

<style scoped>
/deep/.patient-history-tabs .tab-content {
  height: calc(100% - 30px);
}
/deep/.patient-history-tabs .tab-space {
  padding: 0px;
  padding-top: 2em;
}

/deep/.patient-history-tabs {
  height: 100%;
}
/deep/ .nav-pills .nav-item .nav-link {
  min-width: 60px;
}
/deep/ .patient-history-tabs a.nav-link {
  font-size: 13px;
}

/deep/ .sc-chat-window {
  padding-top: 0px !important;
  height: 87.5vh;
}

/deep/ .tasks-list .card-body {
  padding: 15px;
}

.badge-task-type {
  background-color: grey;
}

.badge-task-type-Medication {
  background-color: #9f10f2;
}

.badge-task-type-Observation {
  background-color: #17b8b1;
}

/deep/ .form-group .el-input__inner[readonly] {
  background-color: white !important;
}

.details-lable {
  font-weight: 800;
}

/deep/ .task-status .el-input__inner {
  color: var(--color-primary) !important;
  font-weight: 600;
}

/deep/ .task-status .el-select .el-input .el-select__caret {
  color: var(--color-primary) !important;
}

/deep/ .task-date .el-input__suffix-inner {
  pointer-events: none;
  cursor: default;
  display: none;
}

/deep/ #video-call-tab {
  height: calc(100vh - 100.667px);
}

/deep/.make-video-call-button {
  position: absolute;
  top: 20em;
  inset-inline-end: 50%;
  transform: translateX(50%);
}

[dir="rtl"] .make-video-call-button {
  transform: translateX(-50%);
}

.start-video-text {
  position: absolute;
  top: 26.5em;
  inset-inline-end: 50%;
  transform: translateX(50%);
  width: 100%;
  text-align: center;
}

[dir="rtl"] .start-video-text {
  transform: translateX(-50%);
}

.fullscreen-window {
  width: 100%;
  top: 7vh;
  bottom: 0px;
  inset-inline-end: 0px;
  height: 100%;
  background-color: #f1f1f1;
}

.end-button {
  position: absolute;
  bottom: 5.5em;
  inset-inline-end: 50%;
  transform: translateX(50%);
  z-index: 2022;
}
</style>
